import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  inviteTeamMember,
  getAllTeamMember,
  removeTeamMember,
  checkStatus,
  changeStatus,
} from "./teamMemberAPI";

export const sendTeamMemberInvite = createAsyncThunk(
  "teamMember/invite",
  async (data, thunkAPI) => {
    try {
      const res = await inviteTeamMember(data);
      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data ?? { message: error.message },
      );
    }
  },
);

export const fetchAllMembers = createAsyncThunk(
  "teamMember/all",
  async (_, thunkAPI) => {
    try {
      const res = await getAllTeamMember();
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data ?? { message: error.message },
      );
    }
  },
);

export const removeTeamMemberByUuid = createAsyncThunk(
  "teamMember/remove",
  async (uuid, thunkAPI) => {
    try {
      const res = await removeTeamMember(uuid);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data ?? { message: error.message },
      );
    }
  },
);

export const checkTeamMemberStatus = createAsyncThunk(
  "teamMember/status",
  async (uuid, thunkAPI) => {
    try {
      const res = await checkStatus(uuid);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data ?? { message: error.message },
      );
    }
  },
);

export const changeTeamMemberStatus = createAsyncThunk(
  "teamMember/changeStatus",
  async (data, thunkAPI) => {
    try {
      const res = await changeStatus(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data ?? { message: error.message },
      );
    }
  },
);

const teamMemberSlice = createSlice({
  name: "teamMember",
  initialState: {
    loading: false,
    error: null,
    members: [],
    invitationStatus: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendTeamMemberInvite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendTeamMemberInvite.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(sendTeamMemberInvite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchAllMembers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.members = action.payload;
      })
      .addCase(fetchAllMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(removeTeamMemberByUuid.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeTeamMemberByUuid.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        state.members = state.members.filter(
          (member) => member.uuid !== action.payload,
        );
      })
      .addCase(removeTeamMemberByUuid.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(checkTeamMemberStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkTeamMemberStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.invitationStatus = action.payload;
      })
      .addCase(checkTeamMemberStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(changeTeamMemberStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeTeamMemberStatus.fulfilled, (state, action) => {
        state.loading = false;

        state.error = action;
      })
      .addCase(changeTeamMemberStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default teamMemberSlice.reducer;
